import React, { useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleLoginSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post(`${config.API_BASE_URL_V1}auth/login`, { email, password });
            console.log('response: ', response);
            if (response.status === 200) {
                const agencyUser = response.data.data.user.agencyUser;
                const agencyId = agencyUser ? agencyUser.agencyId : null;

                const userData = {
                    token: response.data.data.token,
                    expires_at: response.data.data.expires_at,
                    user: {
                        email: response.data.data.user.email,
                        agency_id: agencyId ? agencyId.id : null,
                        agency_code: agencyId ? agencyId.agencyCode : null,
                        agency_name: agencyId ? agencyId.name : null,
                        parent_id: agencyId ? agencyId.parentId ?? 0 : 0,
                        type_id: agencyId ? agencyId.businessId ?? 4 : 4,
                        isOwner: agencyUser ? agencyUser.isOwner ?? false : false,
                        name: response.data.data.user.name,
                        surname: response.data.data.user.surname,
                        username: response.data.data.user.username,
                        profile_photo: response.data.data.user.profile_photo,
                    },
                    representive_user: response.data.data.representive_user ?? null,
                };

                console.log('userData: ', userData)
                localStorage.setItem('user_data', JSON.stringify(userData));
                navigate(`/`);
            }
        } catch (error) {
            console.error('Login failed:', error.response?.data || error.message);
            setError('Login failed. Please check your credentials.');
            setPassword('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-wrapper authentication-wrapper">
            <div className="auth-bg-overlay">
                <div className="auth-container">
                    <div className="auth-content">
                        <div className="auth-card">
                            {/* Left Side - Login Form */}
                            <div className="auth-form-side">
                                <div className="logo-container">
                                    <img src="/assets/logo-1.png" className="floating-logo" alt="logo-img"/>
                                </div>
                                <div className="auth-form-header">
                                    <h4>Welcome!</h4>
                                    <p>Sign in to your B2B Product Management Panel</p>
                                </div>

                                <form onSubmit={handleLoginSubmit} className="auth-form">

                                    <div className="form-group">
                                        <div className="input-icon">
                                            <input 
                                                type="email" 
                                                required 
                                                className="form-control form-control-lg" 
                                                value={email} 
                                                onChange={(e) => setEmail(e.target.value)} 
                                                placeholder="Email"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="input-icon">
                                            <input 
                                                type={showPassword ? "text" : "password"} 
                                                required 
                                                className="form-control form-control-lg" 
                                                value={password} 
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Password"
                                            />
                                            <span 
                                                className="input-icon-addon toggle-password" 
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <i className={`isax ${showPassword ? "isax-eye" : "isax-eye-slash"}`}></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="form-group forgot-password">
                                        <a href="/dashboard-forgot-password" className="forgot-link">
                                            Forgot Password?
                                        </a>
                                    </div>

                                    <div className="form-group">
                                        <button 
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary btn-lg btn-block"
                                        >
                                            {loading ? 'Signing in...' : 'Sign In'}
                                        </button>
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger">
                                            Login failed. Please check your credentials.
                                        </div>
                                    )}
                                </form>
                            </div>

                            {/* Right Side - Welcome Content */}
                            <div className="auth-welcome-side">
                                <div className="welcome-content">
                                    <div className="welcome-card main-card">
                                        <h2>B2B Product Management Solutions</h2>
                                        <p>Your Trusted Partner in Tourism Industry</p>
                                    </div>
                                    <div className="feature-list">
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-building"></i>
                                            </div>
                                            <p>24/7 Product Booking System</p>
                                        </div>
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-calendar"></i>
                                            </div>
                                            <p>Transfers & Tours</p>
                                        </div>
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-chart"></i>
                                            </div>
                                            <p>Exclusive Rates & Deals</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="copyright-footer">
                <p>Copyright &copy; {new Date().getFullYear()}. All rights reserved., 
                    <a href="https://cornleth.com">Cornleth</a>. Powered with Passion by <a href="https://bew.com.tr?utm_source=cornleth-b2b-login">Bew</a>
                </p>
            </div>

            <style>{`
                .auth-bg-overlay {
                    background: linear-gradient(135deg, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.75)),
                                url('https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?q=80') no-repeat center center fixed;
                    background-size: cover;
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    position: relative;
                }

                .cappadocia-text {
                    position: absolute;
                    bottom: 80px;
                    right: 40px;
                    font-size: 120px;
                    font-weight: 800;
                    color: rgba(255, 255, 255, 0.1);
                    letter-spacing: 8px;
                    z-index: 0;
                }

                .auth-container {
                    width: 100%;
                    max-width: 1200px;
                    margin: 0 auto;
                }

                .auth-content {
                    display: flex;
                    justify-content: center;
                }

                .auth-card {
                    background: #fff;
                    border-radius: 20px;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                    overflow: hidden;
                    display: flex;
                    width: 100%;
                    max-width: 1000px;
                }

                .auth-form-side {
                    flex: 1;
                    padding: 40px;
                    background: #fff;
                }

                .auth-welcome-side {
                    flex: 1;
                    padding: 40px;
                    background: rgba(14, 23, 43, 0.75);
                    backdrop-filter: blur(10px);
                    color: #fff;
                    display: flex;
                    align-items: center;
                    position: relative;
                    overflow: hidden;
                }

                .logo-container {
                    text-align: center;
                    margin-bottom: 30px;
                }

                .floating-logo {
                    width: 200px;
                    animation: float 3s ease-in-out infinite;
                }

                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                    100% { transform: translateY(0px); }
                }

                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.02); }
                    100% { transform: scale(1); }
                }

                @keyframes slideIn {
                    0% { transform: translateX(20px); opacity: 0; }
                    100% { transform: translateX(0); opacity: 1; }
                }

                .auth-form-header {
                    text-align: center;
                    margin-bottom: 30px;
                }

                .auth-form-header h4 {
                    font-size: 24px;
                    margin-bottom: 10px;
                    color: #1a1a1a;
                }

                .auth-form-header p {
                    color: #666;
                }

                .form-group {
                    margin-bottom: 20px;
                }

                .input-icon {
                    position: relative;
                }

                .input-icon-addon {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #666;
                }

                .input-icon-addon:first-child {
                    left: 15px;
                }

                .input-icon-addon:last-child {
                    right: 15px;
                }

                .form-control {
                    width: 100%;
                    padding: 12px 15px 12px 45px;
                    border: 1px solid #e0e0e0;
                    border-radius: 10px;
                    font-size: 16px;
                    transition: all 0.3s ease;
                }

                .form-control:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
                    outline: none;
                }

                .toggle-password {
                    cursor: pointer;
                }

                .forgot-link {
                    color: #2563eb;
                    text-decoration: none;
                    font-size: 14px;
                    transition: color 0.3s ease;
                }

                .forgot-link:hover {
                    color: #1d4ed8;
                }

                .btn {
                    width: 100%;
                    padding: 12px;
                    border: none;
                    border-radius: 10px;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .btn-primary {
                    background: linear-gradient(135deg, #1e3a8a, #1e40af);
                    color: white;
                }

                .btn-primary:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(30, 58, 138, 0.2);
                }

                .btn-primary:disabled {
                    background: #94a3b8;
                    cursor: not-allowed;
                }

                .alert-danger {
                    background: #fee2e2;
                    border: 1px solid #fecaca;
                    color: #dc2626;
                    padding: 12px;
                    border-radius: 10px;
                    margin-top: 20px;
                }

                .welcome-content {
                    width: 100%;
                }

                .welcome-card.main-card {
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(5px);
                    border-radius: 15px;
                    padding: 15px;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    margin-bottom: 20px;
                    text-align: center;
                    animation: pulse 3s ease-in-out infinite;
                    transition: all 0.3s ease;
                }

                .welcome-card.main-card:hover {
                    transform: translateY(-5px);
                    background: rgba(255, 255, 255, 0.15);
                }

                .feature-list {
                    display: grid;
                    gap: 15px;
                }

                .feature-card {
                    background: rgba(255, 255, 255, 0.08);
                    backdrop-filter: blur(5px);
                    border-radius: 12px;
                    padding: 12px 15px;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    display: flex;
                    align-items: center;
                    transition: all 0.3s ease;
                    animation: slideIn 0.5s ease-out forwards;
                    opacity: 0;
                }

                .feature-card:nth-child(1) {
                    animation-delay: 0.1s;
                }

                .feature-card:nth-child(2) {
                    animation-delay: 0.2s;
                }

                .feature-card:nth-child(3) {
                    animation-delay: 0.3s;
                }

                .feature-card:hover {
                    background: rgba(255, 255, 255, 0.12);
                    transform: translateX(5px);
                }

                .feature-icon {
                    width: 40px;
                    height: 40px;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 15px;
                    backdrop-filter: blur(5px);
                    transition: all 0.3s ease;
                }

                .feature-card:hover .feature-icon {
                    transform: rotate(10deg);
                    background: rgba(255, 255, 255, 0.2);
                }

                .feature-card p {
                    color: #fff;
                    font-size: 16px;
                    margin: 0;
                    transition: all 0.3s ease;
                }

                .feature-card:hover p {
                    transform: translateX(5px);
                }

                .welcome-content h2 {
                    font-size: 28px;
                    margin-bottom: 10px;
                    color: #fff;
                }

                .welcome-content > p {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 16px;
                    margin-bottom: 0;
                }

                .copyright-footer {
                    position: absolute;
                    bottom: 20px;
                    left: 0;
                    right: 0;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.9);
                }

                .copyright-footer a {
                    color: #fff;
                    text-decoration: none;
                    margin-left: 5px;
                    font-weight: 500;
                }

                .copyright-footer a:hover {
                    text-decoration: underline;
                }

                @media (max-width: 768px) {
                    .auth-card {
                        flex-direction: column;
                        margin: 20px;
                    }

                    .auth-welcome-side {
                        display: none;
                    }

                    .auth-form-side {
                        padding: 30px;
                    }
                }
            `}</style>
        </div>
    );
}
